import { render, staticRenderFns } from "./ProfileNews.vue?vue&type=template&id=44715f83&"
import script from "./ProfileNews.vue?vue&type=script&lang=js&"
export * from "./ProfileNews.vue?vue&type=script&lang=js&"
import style0 from "./ProfileNews.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports